import { Link } from 'react-router-dom';

export default function TestimonialCard({ testimonial }) {
  return (
    <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 relative">
      <div className="text-blue-600 text-6xl absolute top-4 left-4 opacity-10 font-serif">&ldquo;</div>
      <div className="relative z-10">
        {testimonial.metric_highlight && (
          <div className="inline-block bg-blue-50 text-blue-700 text-sm font-semibold px-3 py-1 rounded-full mb-4">
            {testimonial.metric_highlight}
          </div>
        )}
        <p className="text-gray-600 mb-6 italic leading-relaxed">&ldquo;{testimonial.quote}&rdquo;</p>
        <div className="flex items-center">
          {testimonial.author_image && (
            <img src={testimonial.author_image} alt={testimonial.author_name} className="w-12 h-12 rounded-full mr-4 object-cover" />
          )}
          <div>
            <h4 className="font-semibold text-gray-900">{testimonial.author_name}</h4>
            <p className="text-gray-500 text-sm">{testimonial.author_role}</p>
          </div>
          {testimonial.case_study_slug && (
            <Link to={`/case-studies/${testimonial.case_study_slug}`} className="ml-auto text-blue-600 text-sm hover:underline">
              View case study
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
